import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const accountAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Account>>('/api/info/accounts', { params }).then(({ data }) => data),
  update: (id: number | string, data: AccountForm) => http.put<unknown>(`/api/edit/accounts/${id}`, { data }),
  create: (data: AccountForm) => http.post<CreateResponse<Account>>(`/api/add/accounts`, { data }),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/accounts/${id}`),
  detail: (id: number | string) => http.get<Account>(`/api/info/accounts/${id}`).then(({ data }) => data),
  detail_by_phone: (phone: string) => http.get<Account>(`/api/info/accounts/phone/${phone}`).then(({ data }) => data),
  history: (id: number | string) =>
    http.get<SaleHistory<Account>[]>(`/api/info/history_accounts/${id}`).then(({ data }) => data),
};

export const accountQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetAccounts', params] as const,
      queryFn: () => accountAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  detail: (id: number | string) =>
    ({
      queryKey: ['GetDetailAccount', id] as const,
      queryFn: () => accountAPI.detail(id),
    }) as const satisfies QueryOptions,
  detail_by_phone: (phone: string) => ({
    queryKey: ['GetDetailAccountByPhone', phone] as const,
    queryFn: () => accountAPI.detail_by_phone(phone),
  }),
  history: (id: number | string) =>
    ({
      queryKey: ['GetAccountHistory', id] as const,
      queryFn: () => accountAPI.history(id),
    }) as const satisfies QueryOptions,
};
